import * as React from 'react'
import type { SVGProps } from 'react'
const SvgSettingsAdjust = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.58 10.208H4.666a.875.875 0 1 1 0-1.75h10.912a3.21 3.21 0 0 1 6.176 0h1.579a.875.875 0 0 1 0 1.75h-1.58a3.21 3.21 0 0 1-6.175 0m1.629-.875a1.458 1.458 0 1 1 2.916 0 1.458 1.458 0 0 1-2.916 0M12.421 19.542h10.913a.875.875 0 0 0 0-1.75H12.42a3.21 3.21 0 0 0-6.175 0H4.667a.875.875 0 1 0 0 1.75h1.58a3.21 3.21 0 0 0 6.174 0m-4.546-.875a1.458 1.458 0 1 1 2.917 0 1.458 1.458 0 0 1-2.917 0"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgSettingsAdjust
